import token, { tokenToVars } from '../token';
import Sticky from './sticky';

export { Sticky };
export default tokenToVars(Sticky, token);
